import { useTranslation } from 'react-i18next';
import { GenericSettings } from '../components/GenericSettings';
import { NotificationEntityType } from 'types';
import { translations } from 'app/locales/i18n';

export const CustomerSettings = () => {
  const { t } = useTranslation();
  return (
    <GenericSettings
      entityType={NotificationEntityType.CUSTOMER}
      header={t(translations.customerListing.customerListing)}
      label={t(translations.customerListing.customers)}
      emptyTableText={t(translations.customerListing.noCustomers)}
    />
  );
};
